@if (!environment.production) {
  <span class="env-badge env-badge-warning" role="status">
    <span class="env-dot" aria-hidden="true"></span>
    Ambiente de {{ environment.label.toLowerCase() }}
  </span>
}
